import type { TFunction } from 'i18next';
import type { ConversationTranscript } from '@/entities/conversations';
import { getSpeakerLabel } from '../speaker';

type LabelsT = TFunction<readonly ['dialogs', 'common']>;

/** Говорящий реплики с его ролью — подпись реплики в ленте режима и в полях перебивания */
export const getPhraseSpeakerLabel = (phrase: ConversationTranscript, t: LabelsT): string =>
  phrase.person ? getSpeakerLabel(phrase.person, t) : t('dialogs:transcriptEdit.speakerUnknown');

/** Реплика одной строкой — говорящий и текст: так перебивание называет свои реплики */
export const describePhrase = (phrase: ConversationTranscript, t: LabelsT): string =>
  `${getPhraseSpeakerLabel(phrase, t)}: ${phrase.text ?? ''}`;
